'use es6';

import keyMirror from 'react-utils/keyMirror';
import { byName } from 'ContentUtils/constants/TemplateTypes';
export const systemEmailTemplateTypes = Object.freeze(keyMirror({
  [byName.subscription_preferences.id]: null,
  [byName.unsubscribe_confirmation.id]: null,
  [byName.unsubscribe_simple.id]: null
}));
export const systemPageTemplateTypes = Object.freeze(keyMirror({
  [byName.error_page.id]: null,
  [byName.password_prompt_page.id]: null,
  [byName.search_results.id]: null
}));
export const systemMembershipTemplateTypes = Object.freeze(keyMirror({
  [byName.membership_login.id]: null,
  [byName.membership_register.id]: null,
  [byName.membership_reset.id]: null,
  [byName.membership_reset_request.id]: null
}));